module.exports = __webpack_public_path__ + "assets/2cd805af00c2237594dc212d7f6592ca.svg";